// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"3c628124","48":"11bc2c75","130":"6e6fa915","239":"0286edb8","366":"df8ac568","368":"1cdae49a","605":"fb4b1ad2","742":"831deb25","787":"245799a7"}[chunkId] + ".chunk.js";
};